import { useToast } from "@chakra-ui/react";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { AxiosError } from "axios";

import { useEnvironment } from "@/common/contexts/EnvironmentContext";
import { useErrorToast } from "@/common/hooks/useErrorToast";
import api from "@/common/utils/api";
import { ErrorResponse } from "@reflag/shared/api";

import { orgQueryKeys } from "./orgQueryKeys";

export function useMemberDeleteMutation(memberId: string) {
  const toast = useToast();
  const queryClient = useQueryClient();
  const errorToast = useErrorToast();
  const { org } = useEnvironment();

  return useMutation<object, AxiosError<ErrorResponse>, void>({
    mutationKey: orgQueryKeys.member(org.id, memberId),

    mutationFn: () =>
      api
        .delete<"/orgs/:orgId/members/:memberId">(
          `/orgs/${org.id}/members/${memberId}`,
        )
        .then((res) => res.data),

    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: orgQueryKeys.members(org.id),
      });
      queryClient.invalidateQueries({
        queryKey: orgQueryKeys.domains(org.id),
      });

      toast({
        title: "Member removed from organization",
        status: "success",
      });
    },

    onError: () => {
      errorToast({
        title: "Failed to remove member from organization",
      });
    },
  });
}
